import React from 'react';

import {RouteData} from '../types';

/**
 * The entity named "weave" is claimed by a past wandb employee.
 * This is doing the quick thing to redirect this path to the weave site instead.
 */
export const REDIRECT_WEAVE_ENTITY_ROUTE_DATA: RouteData = {
  additionalProps: {
    allowIframes: false,
    routeName: 'WeaveEntity',
  },
  exact: true,
  isPrivateRoute: false,
  path: '/weave',
  RouteComponent: React.lazy(
    () => import('../../pages/EntityPage/RedirectToWeaveSite')
  ),
};
